import React from 'react'

import Button from 'components/Button'

type Props = {
  disabled: boolean,
  isCallActive: boolean,
  loading: boolean,
  onClick: () => void,
};

export default function SupportCallButton({ disabled, isCallActive, loading, ...props }: Props) {
  return (
    <Button {...props} disabled={disabled} loading={loading} className="SupportCallButton">
      {isCallActive ? 'End call' : 'Get phone support' }
    </Button>
  )
}
